import { name, i } from '@/utils/desc'

export default [
  {
    name: 'IDR. Malen<br/>Gomez-Garcia',
    title: 'Creative Director',
    description: `
      With almost twenty years of invaluable experience in the interior design industry &
      a sincere passion to understand each client's behavior, needs & wants,
      ${name('Malen')} has designed hundreds of projects that her clients have called home.
      Her natural eye & style coupled with the right balance of form & function has
      molded the distinct character of an ${i('IdeaForma')} home.`,
    src: 'Malen Garcia.png'
  },
  {
    name: 'Nina<br/>Gomez-Camacho',
    title: 'General Manager',
    description: `
      ${name('Nina')}, with her love for learning proven
      by achieving two master's degrees, one in
      ${i('Business Management')}, and another in
      ${i('Entrepreneurship')}, plus significant brand & marketing
      experience in other industries, has grown the business from a one-man team to a fully functional
      interior design & project management firm. With ${name("Nina's")} crystal clear focus on
      ${i("IdeaForma's")} mission & vision, that is to be the preferred ${i('Home Management Company')},
      there's no stopping this team of siblings that she leads.`,
    src: 'Nina Camacho.png'
  },
  {
    name: 'Rico<br/>Gomez',
    title: 'Asst. General Manager',
    description: `
      Having handled multiple projects of different styles,
      paces & clients all through out his five years in the firm,
      ${name('Rico')} has perfected the smoothest implementation of the unique
      ${i('IdeaForma')} design process & over-all management.
      With almost a hundred projects under his sleeve, his project management,
      finance & administrative skills are truly quite remarkable.`,
    src: 'Rico Gomez.png'
  },
  {
    name: 'Lisa<br/>Gomez-Quirante',
    title: 'Marketing Head',
    description: `
      With customer experience in this highly competitive service industry
      as her main priority, ${name('Lisa')} has recently introduced significant &
      personal touches in the whole ${i('IdeaForma')} experience.
      This marketing expert's decade-long experience with one of the country's
      most successful high-end developers, ${i('Rockwell Land Corp.')}, has infused
      her with the greatest attention to detail, knowing that it's the small things
      that truly matter.`,
    src: 'Lisa Gomez.png'
  },
  {
    name: 'Erica<br/>Gomez',
    title: 'Marketing Associate',
    description: `
      With her fair share of outside experience in the client-servicing industry,
      particularly as a senior account manager of
      ${i('Nuworks Interactive Labs Inc.')},
      a young & vibrant advertising agency,
      ${name('Erica')} is now this design firm's key to moving the ${i('IdeaForma')}
      service experience closer to perfection. Each project is unique and handled in
      the most personal manner but she ensures that every client recognizes those
      service trademarks of notable excellence & selfless service.`,
    src: 'Erica Gomez.png'
  },
  {
    name: 'Debbie<br/>Ramos',
    title: 'Finance & Administrative Supervisor',
    // description: 'Dolor pariatur magna eu culpa quis commodo anim pariatur eu exercitation exercitation fugiat et. Exercitation qui ex ullamco in.',
    src: 'Debbie Ramos.png',
    // emphasize: true
  },
  {
    name: 'Mike<br/>Umbao',
    title: 'Administrative Staff',
    // description: 'Ipsum sunt veniam ex et nulla officia consequat mollit excepteur. Nostrud magna elit excepteur ipsum. Sit fugiat anim aliquip laboris magna officia consectetur eiusmod ex minim id.',
    src: 'Mike Umbao.png'
  },
  {
    name: 'Rachel<br/>Tanada',
    title: 'Sr. Design Associate',
    // description: 'Est excepteur sit sunt voluptate culpa aute magna veniam culpa consectetur. Eiusmod elit irure adipisicing dolor id deserunt commodo enim quis reprehenderit non sunt laborum.',
    src: 'Rachel Tanada.png',
    // emphasize: true
  },
  {
    name: 'Angelica<br/>Jaurigue',
    title: 'Jr. Interior Designer',
    // description: 'Qui sit velit fugiat voluptate reprehenderit nostrud laborum enim sint ipsum cupidatat. Enim dolor mollit nisi aliqua.',
    src: 'Angelica Jaurigue.png'
  },
  {
    name: 'Reneca<br/>Abuso',
    title: 'Jr. Interior Designer',
    // description: 'Aliquip qui officia excepteur est minim aute magna ut anim ex anim non. Tempor velit do consequat Lorem irure minim consectetur exercitation tempor consequat ut sunt Lorem ex.',
    src: 'Reneca Abuso.png'
  },
  {
    name: 'Ally<br/>Asprec',
    title: 'Technical Designer',
    // description: 'Laboris dolore laborum incididunt aliqua amet velit non esse cillum. Aliqua veniam est culpa pariatur proident consequat ullamco tempor ut labore voluptate.',
    src: 'Ally Asprec.png'
  }
]
